import {
  getHopinRoot,
  getHopinSSOApiRoot,
} from '@hopin-team/config-hopin-constants';

import { fetchJSON } from './fetch';

export const buildUserSsoUrl = () => `${getHopinSSOApiRoot()}/users/sso`;

export const postUserSso = (event_slug: string) =>
  fetchJSON(buildUserSsoUrl(), {
    method: 'POST',
    credentials: 'include',
    body: { registrations: { event_slug } },
  });

export const userIntrospectPath = '/public/users/introspect';

export const getUserAsync = (token: string) =>
  fetchJSON(userIntrospectPath, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const buildSignInUrl = () => `${getHopinRoot()}/widget_sign_in`;

export const buildSignOutUrl = () => `${getHopinRoot()}/widget_sign_out`;
